<template>
  <div class="p-3">
    <div
      class="justify-end items-center my-3"
      :class="[$vuetify.breakpoint.lgAndUp ? 'flex justify-end' : 'flex-col']"
    >
      <div
        class="items-center justify-end mb-0"
        :class="[$vuetify.breakpoint.lgAndUp ? 'flex' : 'flex-col']"
      >
        <v-col
          :cols="$vuetify.breakpoint.lgAndUp ? '' : '12'"
          :class="[
            $vuetify.breakpoint.lgAndUp ? 'py-0 pr-0 mb-2' : 'ml-auto py-2',
          ]"
        >
          <div class="custom-input-group">
            <v-select
              :items="selectItems"
              v-model="selectValue"
              solo
              flat
              dense
              hide-details
              outlined
              class="select-input"
              label="Select"
              :style="{ width: '150px' }"
              @change="handleSelect"
            />
            <v-text-field
              class="text-input"
              v-model="filterCase"
              :label="searchPlaceholder"
              :placeholder="searchPlaceholder"
              hide-details
              solo
              flat
              dense
              clearable
              outlined
              :style="{ width: '300px' }"
              @input="handleInput"
            ></v-text-field>
          </div>
        </v-col>
        <v-col
          :cols="$vuetify.breakpoint.lgAndUp ? '' : '12'"
          :class="[$vuetify.breakpoint.lgAndUp ? 'py-0 pr-0' : 'ml-auto py-2']"
        >
          <v-text-field
            class="wfm-search-fields"
            v-model="filterCustomer"
            :label="`Search by ${
              tabText?.customerTable?.displayName || 'Customer'
            }`"
            :placeholder="`Search by ${
              tabText?.customerTable?.displayName || 'Customer'
            }`"
            hide-details
            solo
            flat
            clearable
            outlined
            prepend-inner-icon="mdi-magnify"
            @input="handleInput"
          ></v-text-field>
        </v-col>
        <div
          class="justify-end mb-2 items-center"
          :class="[$vuetify.breakpoint.lgAndUp ? 'inline-flex' : 'inline-flex']"
        >
          <v-btn
            @click="addNewCase"
            :color="$vuetify.theme.currentTheme.primary"
            class="ml-4 white--text"
            v-tooltip="{
              text: 'Add case',
            }"
            v-show="canWrite"
          >
            Add Case
            <v-icon right dark>mdi-plus</v-icon>
          </v-btn>

          <FilterPopOver class="p-2" :selectedCount="selectedCount">
            <v-card outlined class="w-72 max-h-96">
              <v-list>
                <v-list-item class="px-0">
                  <v-col class="py-0 mt-3">
                    <v-autocomplete
                      v-model="filterAssignedTo"
                      label="Select Assignee"
                      placeholder="Select Assignee"
                      :items="users"
                      item-text="fullName"
                      item-value="_id"
                      outlined
                      hide-details
                      dense
                      class="mb-1"
                      clearable
                      @change="handleChange"
                      @keydown.enter="filterAssignedTo = setDataOnEnter(users)"
                    >
                      <template v-slot:prepend-item>
                        <v-list-item
                          ripple
                          @mousedown.prevent
                          @click="handleUnassignedCases"
                          class="unassignedOptions"
                        >
                          <v-list-item-content>
                            <v-list-item-title class="py-0">
                              Unassigned
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider class=""></v-divider>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-list-item>
                <v-list-item class="px-0">
                  <v-col class="py-0">
                    <v-select
                      v-model="filterCaseOutcome"
                      label="Select Outcome"
                      placeholder="Select Outcome"
                      :items="userDefinedStatusOptions"
                      hide-details
                      outlined
                      dense
                      clearable
                      @change="handleChange"
                    ></v-select>
                  </v-col>
                </v-list-item>
                <v-list-item
                  class="px-0"
                  v-if="branches.length"
                  v-show="isBranchFeatureVisible('ASSIGN_BRANCH_TO_ENTITY')"
                >
                  <v-col class="py-0">
                    <v-select
                      v-model="filterBranch"
                      label="Select Branch"
                      placeholder="Select Branch"
                      :items="branches"
                      item-text="branchName"
                      item-value="_id"
                      hide-details
                      outlined
                      dense
                      clearable
                      @change="handleChange"
                    ></v-select>
                  </v-col>
                </v-list-item>
                <v-list-item class="px-0">
                  <v-col class="py-0">
                    <v-autocomplete
                      v-model="filterStatus"
                      label="Select Status"
                      placeholder="Select Status"
                      :items="caseStatusOptions"
                      item-text="label"
                      item-value="value"
                      hide-details
                      outlined
                      dense
                      clearable
                      @change="handleChange"
                    ></v-autocomplete>
                  </v-col>
                </v-list-item>
                <v-list-item class="px-0">
                  <v-col class="py-0">
                    <v-menu
                      v-model="menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          label="Select Date Range"
                          placeholder="Select Date Range"
                          v-model="formattedDate"
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          hide-details
                          outlined
                          dense
                          clearable
                          v-on="on"
                          @click:clear="onDateCleared"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="dates"
                        @input="onDateSelected"
                        no-title
                        @change="menu = false"
                        range
                        scrollable
                      />
                    </v-menu>
                  </v-col>
                </v-list-item>
              </v-list>
            </v-card>
          </FilterPopOver>
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on">
                <v-icon size="28px" color="grey">mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                :color="$vuetify.theme.currentTheme.primary"
                v-show="canWrite"
                @click="uploadCases('Create')"
              >
                Bulk Create {{ tabText?.caseTable?.displayName || "Cases" }}
              </v-list-item>
              <v-list-item
                :color="$vuetify.theme.currentTheme.primary"
                @click="uploadCases('Update')"
                v-show="canEdit"
              >
                Bulk Update Cases
              </v-list-item>
              <v-list-item
                @click="handleExportKeys"
                :loading="exportLoading"
                :disabled="exportLoading"
                :color="$vuetify.theme.currentTheme.primary"
                v-show="canEdit"
              >
                Export Cases
                <v-icon right dark>mdi-download</v-icon>
              </v-list-item>
              <v-list-item
                @click="handleShowDialog('status')"
                :disabled="!selected.length"
                v-show="canEdit"
              >
                <v-list-item-title>Update FollowUp Outcome</v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="handleShowDialog('FEName')"
                :disabled="!selected.length"
                v-show="canEdit"
              >
                <v-list-item-title>Assign Selected Cases</v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="handleShowDialog('Branches')"
                :disabled="!selected.length"
                v-show="
                  isBranchFeatureVisible('ASSIGN_BRANCH_TO_ENTITY') && canWrite
                "
              >
                <v-list-item-title>Assign Branch</v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="handleShowDialogDelete('delete')"
                :disabled="!selected.length"
                v-show="canDelete"
              >
                <v-list-item-title>Delete Selected Cases</v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="handleShowDialogDeleteAll('deleteAll')"
                :disabled="!cases.length"
                v-show="canDelete"
              >
                <v-list-item-title>Delete All Cases</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </div>
    </div>

    <div class="overflow-x-auto overflow-y-auto">
      <v-data-table
        :headers="headers"
        :items="cases"
        class="pl-7 pr-7 pt-4 text-sm"
        :footer-props="{ itemsPerPageOptions: [5, 10, 15, 30, 50] }"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loadTable"
        fixed-header
        show-select
        item-key="caseNo"
        v-model="selected"
      >
        <template v-slot:item.caseNo="{ item }">
          <td
            class="px-4 py-6 font-semibold hover:text-blue-700 dark-hover-text cursor-pointer"
            @click="caseDetails(item)"
          >
            {{ item.caseNo }}
            <span>({{ item.tasks?.length }})</span>
          </td>
        </template>
        <template v-slot:item.typeOfLoan="{ item }">
          <td class="px-4 py-6 font-semibold">
            {{ convertTitle(item?.typeOfLoan) || "-" }}
          </td>
        </template>
        <template v-slot:item.bkt="{ item }">
          <td class="px-4 py-6 font-semibold">{{ item.bkt }}</td>
        </template>
        <template v-slot:item.pos="{ item }">
          <td class="px-4 py-6 font-semibold">{{ item.pos }}</td>
        </template>
        <template v-slot:item.distanceFromBranch="{ item }">
          <td v-if="getBranchDistance(item)" class="px-4 py-6 font-semibold">
            {{ getBranchDistance(item) }}
          </td>
          <td v-else class="px-4 py-6 font-semibold">
            <button
              class="btn btn-primary"
              @click="getDistanceFromBranch(item)"
            >
              Calculate Distance
            </button>
          </td>
        </template>
        <template v-slot:item.emiAmount="{ item }">
          <td class="px-4 py-6 font-semibold">{{ item.emiAmount }}</td>
        </template>
        <template v-slot:item.tenure="{ item }">
          <td class="px-4 py-6 font-semibold">
            {{ item.tenure }}
          </td>
        </template>
        <template
          v-for="option in dynamicColumns"
          v-slot:[`item.${option.value}`]="{ item }"
        >
          <td :key="option.value" class="px-4 py-6 font-semibold">
            {{
              item?.totalCollectedAmount
                ? item?.totalCollectedAmount[option?.value]
                : "-"
            }}
          </td>
        </template>

        <template v-slot:item.tat="{ item }">
          <td class="px-4 py-6 font-semibold">{{ calculateTAT(item) }}</td>
        </template>
        <template v-slot:item.caseStartDate="{ item }">
          <td class="px-4 py-6 font-semibold">
            {{
              item.caseStartDate
                ? $dayjs(item.caseStartDate).format("DD/MM/YYYY")
                : ""
            }}
            <br />
            {{
              item.caseStartDate
                ? $dayjs(item.caseStartDate).format("hh:mm A")
                : "-"
            }}
          </td>
        </template>
        <template v-slot:item.branchName="{ item }">
          <td class="px-4 py-6 font-semibold">{{ findBranch(item) }}</td>
        </template>
        <template v-slot:item.assignedTo="{ item }">
          <td class="px-2 py-6 font-semibold">
            <template>
              <v-autocomplete
                v-model="item.assignedTo"
                :items="users"
                item-text="fullName"
                item-value="_id"
                label="Assigned To"
                placeholder="Assigned To"
                hide-details
                flat
                solo
                v-tooltip="{ text: `${employeeFullName(item.assignedTo)}` }"
                multiple
                :disabled="item.status === 'CLOSED'"
                @change="caseStatusUpdate($event, item, 'assignedTo')"
              >
                <template v-slot:prepend-item>
                  <v-list-item
                    ripple
                    @mousedown.prevent
                    v-show="item.assignedTo"
                    @click="caseStatusUpdate('null', item, 'assignedTo')"
                    class="unassignedOptions"
                  >
                    <v-list-item-content>
                      <v-list-item-title class="py-0">
                        Unassigned
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class=""></v-divider>
                </template>
              </v-autocomplete>
            </template>
          </td>
        </template>
        <template v-slot:item.outcome="{ item }">
          <td class="px-2 py-6 font-semibold">
            <v-select
              v-model="item.userDefinedCaseStatus"
              label="Outcome"
              :items="userDefinedStatusOptions"
              hide-details
              flat
              solo
              :disabled="item.status === 'CLOSED'"
              @change="
                (outcome) =>
                  caseStatusUpdate(outcome, item, 'userDefinedCaseStatus')
              "
            >
            </v-select>
          </td>
        </template>
        <template v-slot:item.status="{ item }">
          <OrderStatuses
            :orderStatus="item.status"
            :statuses="caseStatusOptions"
            @statusChange="(status) => caseStatusUpdate(status, item, 'status')"
          />
        </template>
        <template v-slot:item.action="{ item }">
          <td class="px-4 py-6">
            <action-button
              :item="item"
              :canEdit="canEdit"
              :canWrite="canWrite"
              :canDelete="canDelete"
              :handleEdit="() => casesEdit(item)"
              :addTaskAction="() => addCaseTask(item)"
              :handleDelete="() => handleDelete(item)"
              :showAddIcon="'mdi-plus'"
              :plusIconText="'Add Visit'"
              :showEditButton="canEdit"
              :showAddTaskButton="canWrite"
              :showDeleteButton="canDelete"
            />
          </td>
        </template>
      </v-data-table>
    </div>

    <v-dialog v-model="openEditCase" width="auto" persistent>
      <AddEditCase
        @caseAdded="handleAdded"
        :editCase="editCase"
        :caseConfig="caseConfig"
      />
    </v-dialog>
    <v-dialog v-model="openUploadCases" max-width="600" persistent>
      <UploadCases
        @updateUploadData="handleAdded"
        @close="closeUpload"
        @downloadSample="exportXlsxFormat"
        :caseConfig="caseConfig"
        :caseAction="caseAction"
      />
    </v-dialog>
    <v-dialog v-model="openAddCaseTask" max-width="600" persistent>
      <AddEditCaseTask
        @caseTaskAdded="handleAdded"
        :editCase="editCase"
        :caseConfig="caseConfig"
      />
    </v-dialog>
    <v-dialog v-model="openCaseDetails" max-width="70rem" persistent>
      <CaseDetails
        :selectedCase="selectedCase"
        :caseConfig="caseConfig"
        @closeDialog="closeDialog"
      />
    </v-dialog>
    <AlertPopUp
      :showConfirmationDialog="showConfirmationDialog"
      :confirmationTitle="'Confirm Delete'"
      :confirmationMessage="'Are you sure you want to delete the case?'"
      :confirmationActionText="'DELETE'"
      :confirmationActionColor="'red'"
      :performAction="caseDelete"
      :cancel="cancel"
    />
    <AlertPopUp
      :showConfirmationDialog="showUpdateVisitDialog"
      :confirmationTitle="'Confirm Update'"
      :confirmationMessage="`Do you want to change pending visits to ${newAssignedTo}?`"
      :confirmationActionText="'UPDATE'"
      :confirmationActionColor="'blue'"
      :performAction="updateVisit"
      :cancel="cancelVisitUpdate"
    />

    <AlertPopUp
      :showConfirmationDialog="showDeleteDialog"
      :confirmationTitle="'Confirm Delete'"
      :confirmationMessage="'Are you sure you want to delete cases?'"
      :confirmationCustomerMessage="'Do you want to delete associated customer with selected cases?'"
      :afterConfirmationMessage="`Please make sure customer is not linked with other cases which you don't want to delete.`"
      :confirmationActionText="'DELETE'"
      :confirmationActionColor="'red'"
      :performAction="casesDeleteFunc"
      :deleteCustomerFunc="handleCheckedUpdate"
      :cancel="handleShowDialogDelete"
      :dialogLable="dialogLable"
      :loading="loading"
      :deleteCustomer="deleteCustomer"
    />

    <AlertPopUp
      :showConfirmationDialog="showDeleteAllDialog"
      :confirmationTitle="'Confirm Delete'"
      :confirmationMessage="'Are you sure you want to delete all cases? Deleted cases cannot be reverted.'"
      :confirmationActionText="'DELETE'"
      :confirmationActionColor="'red'"
      :performAction="deleteAllCases"
      :cancel="handleShowDialogDeleteAll"
      :dialogLable="dialogLable"
      :loading="loading"
    />

    <UpdateCases
      :visible.sync="showDialog"
      :handleShowDialog="handleShowDialog"
      :handleDeleteSelected="handleDeleteSelected"
      :items="selected"
      :users="users"
      :branches="branches"
      :userDefinedStatusOptions="userDefinedStatusOptions"
      :caseConfig="caseConfig"
      :dialogLable="dialogLable"
    >
    </UpdateCases>
    <ExportDynamicColumns
      :showExportDialog="exportDialog"
      :exportKeys="exportColumnHeaders"
      :exportLoading="exportLoading"
      :caseType="caseConfig.name"
      @closeExportDialog="closeExportDialog"
      @exportData="(selectedKeys) => exportCases(selectedKeys)"
    />
  </div>
</template>
<script>
import ActionButton from "@/components/ActionButton";
import AddEditCase from "./AddEditCase";
import CaseDetails from "../CaseDetails";
import UploadCases from "./UploadCases";
import AddEditCaseTask from "../AddEditCaseTask";
import AlertPopUp from "@/components/AlertPopUp";
import OrderStatuses from "../../InventoryManagement/OrderStatuses.vue";
import {
  convertToTitleCase,
  fullName,
  debounce,
  dayHourFormat,
  isModuleFeatureAllowed,
  hasPermission,
  mergeOptions,
  mergeOptionsDetails,
} from "@/utils/common";
import FilterPopOver from "@/components/FilterPopOver.vue";
import ExportDynamicColumns from "../ExportDynamicColumns.vue";
import UpdateCases from "./UpdateCases.vue";
import { setDataOnEnter } from "@/utils/workforce/utils";
import permissionData from "@/utils/permissions";
import _ from "lodash";

export default {
  name: "CaseTable",
  props: {
    caseConfig: Object,
    orgConfig: Object,
  },
  components: {
    ActionButton,
    AddEditCase,
    UploadCases,
    AddEditCaseTask,
    CaseDetails,
    AlertPopUp,
    OrderStatuses,
    FilterPopOver,
    UpdateCases,
    ExportDynamicColumns,
  },
  data() {
    return {
      userOrg: this.$storage.getUniversal("user"),
      userData: this.$store.state.wfmPermissions,
      headers: [],
      subCases: this.$store.state.subCases,
      openEditCase: false,
      openUploadCases: false,
      menu: false,
      showConfirmationDialog: false,
      downloadMenu: false,
      openAddCaseTask: false,
      openCaseDetails: false,
      showUpdateVisitDialog: false,
      selectedCase: null,
      filterCaseOutcome: "",
      filterStatus: "",
      cases: [],
      employees: [],
      editCase: null,
      selectedCaseId: null,
      filterAssignedTo: "",
      filterCase: "",
      loadTable: true,
      exportLoading: false,
      options: { sortBy: [], sortDesc: [], itemsPerPage: 5, page: 1 },
      totalItems: 0,
      filterCustomer: "",
      filterBranch: "",
      newAssignedTo: null,
      visitAssignedTo: null,
      visitId: null,
      dates: [],
      branches: [],
      startDate: null,
      endDate: null,
      awsBaseUrl: process.env.VUE_APP_S3_BASE_URL,
      caseStatusOptions: [
        { label: "Open", value: "OPEN" },
        { label: "Closed", value: "CLOSED" },
        { label: "In-Progress", value: "IN_PROGRESS" },
      ],
      selectedCount: 0,
      selected: [],
      showDialog: false,
      showDeleteDialog: false,
      dialogLable: "",
      deleteCustomer: false,
      loading: false,
      caseAction: "",
      showDeleteAllDialog: false,
      selectValue: "CASE_NO",
      exportDialog: false,
      exportColumnHeaders: [],
      dynamicColumns: [],
    };
  },
  watch: {
    "$route.query.search": function (newQuery) {
      try {
        this.filterCase = newQuery || "";
        this.fetchCases();
      } catch (error) {
        console.log(error);
      }
    },

    filterCase(val) {
      if (!val && this.$route.query.search) {
        this.$router.replace({ query: {} }).catch((err) => {
          if (err.name !== "NavigationDuplicated") {
            throw err;
          }
        });
      }
    },
    caseConfig: {
      async handler(config) {
        const caseQuery = this.$route.query?.search;
        await this.fetchUsers();

        if (caseQuery) {
          this.filterCase = caseQuery;
        }
        if (config) {
          this.fetchCases();
          const fm = config.fieldMappings;
          const mergedOptionsDetails = mergeOptionsDetails(
            config.userDefinedCaseStatus
          );

          const getText = (displayName, key) => displayName || key;
          const branch = {
            text: "Linked Branch",
            value: "branchName",
            sortable: false,
          };

          const action = {
            text: "Action",
            value: "action",
            sortable: false,
            width: "auto",
          };

          const headers = [
            {
              key: "caseNo",
              text: getText(fm.caseNo?.displayName, "caseNo"),
              width: "200px",
            },
            {
              key: "typeOfLoan",
              text: getText(fm.typeOfLoan?.displayName, "typeOfLoan"),
              width: "180px",
            },
            {
              key: "bkt",
              text: getText(fm.bkt?.displayName, "bkt"),
              width: "80px",
            },
            {
              key: "pos",
              text: getText(fm.pos?.displayName, "pos"),
              width: "80px",
            },
            {
              key: "emiAmount",
              text: getText(fm.emiAmount?.displayName, "emiAmount"),
              width: "120px",
            },
            {
              key: "tenure",
              text: getText(fm.tenure?.displayName, "tenure"),
              width: "100px",
            },
            { key: "tat", text: "TAT", width: null },
            { key: "caseStartDate", text: "Case Start Date/Time", width: null },
            {
              key: "assignedTo",
              text: getText(fm.assignedTo?.displayName, "assignedTo"),
              width: "180px",
            },
            {
              key: "outcome",
              text: getText(
                fm.caseOutcomeStatus?.displayName,
                "Follow-Up Outcome"
              ),
              width: "150px",
            },
            ...(config.branch ? [branch] : []),
            {
              key: "status",
              text: getText(fm.status?.displayName, "Status"),
              width: "150px",
            },
            ...(this.canEdit || this.canDelete || this.canWrite
              ? [action]
              : []),
          ];

          const caseOutcomeIndex = headers.findIndex(
            (header) => header.key === "outcome"
          );

          if (config.amountRefField) {
            const Columns = mergedOptionsDetails
              .filter((option) => option.amountVisibility)
              .map((option) => ({
                text: `${option.code} Amt.`,
                value: `${option.code}`,
                key: `${option.code}`,
                width: "100px",
                sortable: false,
              }));
            this.dynamicColumns = Columns;
            if (caseOutcomeIndex !== -1) {
              headers.splice(caseOutcomeIndex + 1, 0, ...Columns);
            }
          }

          const x = headers
            .filter((col) => !col.key || fm[col.key]?.visibility !== false)
            .map((col) => ({
              text: col.text,
              value: col.key || col.text.toLowerCase().replace(/ /g, ""),
              sortable: false,
              width: col.width || undefined,
            }));

          // Adding a fixed column
          if (this.caseConfig?.branch) {
            x.splice(2, 0, {
              text: "Distance From Branch",
              value: "distanceFromBranch",
              sortable: false,
              width: "150px",
            });
          }

          this.headers = x;
        }
      },
      immediate: true,
    },

    options: {
      handler(newPage) {
        // if (newPage.page !== 1) {
        this.fetchCases();
        // }
      },
      deep: true,
    },
    formattedDate() {
      this.updateSelectedCount();
    },
  },
  computed: {
    canEdit() {
      return hasPermission(this.userData, permissionData.collectionEdit);
    },
    canDelete() {
      return hasPermission(this.userData, permissionData.collectionDelete);
    },
    canWrite() {
      return hasPermission(this.userData, permissionData.collectionWrite);
    },
    selectItems() {
      const caseLang = this.caseConfig?.fieldMappings;
      if (caseLang?.bkt?.displayName) {
        return [
          { text: caseLang?.caseNo?.displayName, value: "CASE_NO" },
          { text: caseLang?.bkt?.displayName || "Bucket", value: "BKT" },
        ];
      }
      return [{ text: caseLang?.caseNo?.displayName, value: "CASE_NO" }];
    },
    searchPlaceholder() {
      const caseLang = this.caseConfig?.fieldMappings;
      if (this.selectValue === "BKT") {
        return `Search by ${caseLang?.bkt?.displayName}`;
      }
      return `Search by ${caseLang?.caseNo?.displayName}`;
    },
    caseAssignedLang() {
      // const caseLang = this.caseConfig?.fieldMappings;
      return "caseLang.assignedTo?.displayName";
    },
    tabText() {
      return this.caseConfig?.tableTabMapping;
    },
    users() {
      return [
        ...this.employees.map((emp) => ({
          ...emp,
          fullName: fullName(emp),
        })),
        {
          _id: "null",
          fullName: "Unassigned",
        },
      ];
    },
    userDefinedStatusOptions() {
      return mergeOptions(this.caseConfig?.userDefinedCaseStatus);
    },
    formattedDate() {
      if (this.dates.length === 2) {
        const startDate = this.visibleDate(this.dates[0]);
        const endDate = this.visibleDate(this.dates[1]);
        return `${startDate} to ${endDate}`;
      } else if (this.dates.length === 1) {
        return this.visibleDate(this.dates[0]);
      }
      return "";
    },
    // extractTeams() {
    //   if (this.userOrg.branch) {
    //     return this.teams?.filter((el) => el.branch === this.userOrg.branch);
    //   }
    //   return this.teams;
    // },
  },
  methods: {
    setDataOnEnter,
    async getDistanceFromBranch(item) {
      const params = {
        lat: item.lat,
        long: item.long,
      };
      const distanceFromBranch = await this.getDistanceFromBranch(item);
      this.caseStatusUpdate(distanceFromBranch, item, "distanceFromBranch");

      return this.$axios.get("/workforce/distance-from-branch", params);
    },
    getBranchDistance(item) {
      const distance = _.get(item, "distanceFromBranch.[0].distance");
      return distance ? `${distance} km` : "-";
    },
    isBranchFeatureVisible(feature) {
      return isModuleFeatureAllowed("BRANCH_MANAGEMENT", feature);
    },
    filterParams() {
      const params = {};
      if (this.startDate && this.endDate) {
        params.start = this.startDate;
        params.end = this.endDate;
      }
      if (this.caseConfig?.name) {
        params.caseType = this.caseConfig?.name;
      }
      if (this.filterAssignedTo) {
        params.assignedTo = this.filterAssignedTo;
      }
      if (this.filterCaseOutcome) {
        params.userDefinedCaseStatus = this.filterCaseOutcome;
      }
      if (this.filterStatus) {
        params.status = this.filterStatus;
      }

      if (this.filterCase) {
        if (this.selectValue === "BKT") {
          params.bktSearch = this.filterCase;
        } else {
          params.search = this.filterCase;
        }
      }
      if (this.filterCustomer) {
        params.customerSearch = this.filterCustomer;
      }
      return params;
    },
    async fetchCases() {
      try {
        if (!this.caseConfig?.name) return;
        const { sortBy, sortDesc, page, itemsPerPage } = this.options;
        const filterParams = this.filterParams();
        const params = {
          page,
          limit: itemsPerPage > -1 ? itemsPerPage : this.totalItems,
          ...filterParams,
        };
        if (sortBy.length > 0) {
          params.sortBy = sortBy[0];
        }
        if (sortDesc.length > 0) {
          params.sortOrder = sortDesc[0] ? "desc" : "asc";
        }

        if (this.filterBranch) {
          params.branch = this.filterBranch;
        }
        this.loadTable = true;
        const response = await this.$axios.get("/workforce/collection/cases", {
          params,
        });
        this.cases = response.data?.cases;
        this.loadTable = false;
        this.totalItems = response.data?.pagination?.totalCount;
      } catch (error) {
        this.loadTable = false;
        console.log(error);
        const errorMessage = error?.response?.data?.message || error;
        this.$toast.error(errorMessage);
      }
    },
    async caseStatusUpdate(newValue, item, field) {
      try {
        let payload;
        if (field === "assignedTo") {
          payload = {
            [field]: newValue.map((el) => el),
            acknowledged: "",
          };
        } else {
          payload = {
            [field]: newValue,
            acknowledged: "",
          };
        }
        const id = item._id;
        const response = await this.$axios.put(
          `/workforce/collection/case/${id}`,
          payload
        );
        if (field === "assignedTo") {
          this.visitAssignedTo = newValue;
          const newUser = this.users.find(
            (user) => user._id === item.assignedTo
          );
          // this.newAssignedTo = newUser?.fullName;
          // this.visitId = item.tasks[0]?._id;
          // this.showUpdateVisitDialog = true;
        }
        const successMessage =
          response?.data?.message || "Case updated successfully";
        this.$toast.success(successMessage);
        this.cancel();
      } catch (error) {
        this.$toast.error(error.response?.data?.message);
        console.error(error);
      }
    },
    async updateVisit() {
      const payload = {
        assignedTo: this.visitAssignedTo,
      };
      await this.$axios.put(
        `/workforce/collection/case/task/${this.visitId}`,
        payload
      );
      this.$toast.success(
        `Pending visits assigned to ${this.newAssignedTo} successfully.`
      );
      this.cancelVisitUpdate();
    },
    handleDelete(item) {
      this.showConfirmationDialog = true;
      this.selectedCaseId = item._id;
    },
    async caseDelete() {
      try {
        const params = {};
        if (this.caseConfig.name) {
          params.caseType = this.caseConfig.name;
        }
        const response = await this.$axios.delete(
          `/workforce/collection/case/${this.selectedCaseId}`,

          params
        );
        const index = this.cases.findIndex(
          (caseEl) => caseEl._id === this.selectedCaseId._id
        );
        if (index !== -1) {
          this.cases.splice(index, 1);
        }
        this.selectedCaseId = null;
        const successMessage =
          response?.data?.message || "Case deleted successfully.";
        this.$toast.success(successMessage);
        this.cancel();
      } catch (error) {
        const errorMessage =
          error?.response?.data?.message ||
          "An error occurred while deleting the case.";
        this.$toast.error(errorMessage);
        console.error(error);
      }
    },
    async deleteAllCases() {
      this.loading = true;
      try {
        const caseType = this.caseConfig?.name;
        const response = await this.$axios.delete(
          `/workforce/collection/case?caseType=${caseType}`
        );
        this.loading = false;
        if (response?.data?.success) {
          this.$toast.success(response?.data?.message);
          this.handleShowDialogDeleteAll(false);
        }
      } catch (error) {
        this.loading = false;
        const errorMessage =
          error?.response?.data?.message ||
          "An error occurred while deleting the case.";
        this.$toast.error(errorMessage);
        console.error(error);
      }
    },

    async singleCaseDelete(item, params) {
      try {
        let customerId = item?.customer?._id;
        let selectedCaseId = item._id;
        let url;
        if (this.deleteCustomer) {
          url = `/workforce/collection/case/${selectedCaseId}?customerId=${customerId}`;
        } else {
          url = `/workforce/collection/case/${selectedCaseId}`;
        }
        let response = await this.$axios.delete(url, params);
        return response.data;
      } catch (error) {
        console.error(error);
      }
    },
    async casesDeleteFunc() {
      this.loading = true;
      const params = {};
      if (this.caseConfig.name) {
        params.caseType = this.caseConfig.name;
      }
      const promises = [];

      // Make API calls and store promises in the array
      this.selected?.forEach(async (item) => {
        promises.push(this.singleCaseDelete(item, params));
      });

      // Wait for all API calls to complete
      try {
        const results = await Promise.all(promises);

        if (!results.includes(undefined)) {
          this.$toast.success("Cases deleted successfully.");
        }
        this.loading = false;
        this.deleteCustomer = false;
        this.selected = [];
        this.handleShowDialogDelete(false);
      } catch (error) {
        const errorMessage =
          error?.response?.data?.message ||
          "An error occurred while deleting the case.";
        this.$toast.error(errorMessage);
        console.error(error);
      }
    },

    handleCheckedUpdate(value) {
      this.deleteCustomer = value;
    },

    async fetchUsers() {
      try {
        const params = {
          limit: "*",
          sortBy: "firstName",
          sortOrder: "asc",
        };
        if (
          this.userOrg?.branch &&
          !this.userOrg?.role?.includes("WFM_ADMIN")
        ) {
          params.branch = this.userOrg?.branch;
        }
        if (this.caseConfig.branch) {
          params.branch = this.caseConfig?.branch;
        }
        const response = await this.$axios.get("/workforce/v2/users", {
          params,
        });
        this.employees = response.data?.users;
      } catch (error) {
        console.log(error);
      }
    },
    onDateSelected() {
      if (this.dates.length === 2) {
        this.startDate = this.formatDate(this.dates[0]);
        this.endDate = this.formatDate(this.dates[1]);
        this.options.page = 1;
        this.fetchCases();
      } else {
        this.startDate = this.formatDate(this.dates[0]);
        this.endDate = null;
      }
    },
    onDateCleared() {
      this.dates = [];
      this.startDate = null;
      this.endDate = null;
    },
    exportXlsxFormat() {
      const XLSX = require("xlsx");
      const restructuredData = this.prepareData(this.subCases);
      const caseType = this.caseConfig?.name;
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.aoa_to_sheet(restructuredData);
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      XLSX.writeFile(workbook, `${caseType}_Case.xlsx`);
    },
    prepareData(data) {
      const tableData = [];

      data.forEach(() => {
        const row = [];
        tableData.push(row);
      });

      const headerRow = [];
      const uniqueHeaders = new Set();
      const subCase = this.caseConfig;

      if (subCase.fieldMappings) {
        Object.values(subCase?.fieldMappings).forEach((field) => {
          if (
            field &&
            field?.visibility &&
            field?.displayName &&
            !uniqueHeaders.has(field?.displayName)
          ) {
            headerRow.push(field?.displayName);
            uniqueHeaders.add(field?.displayName);
          }
        });
      }

      if (subCase?.additionalColumns) {
        Object.values(subCase?.additionalColumns)?.forEach((add) => {
          if (add?.displayName && !uniqueHeaders.has(add.displayName)) {
            headerRow.push(add.displayName);
            uniqueHeaders.add(add.displayName);
          }
        });
      }

      const addressFields = [];
      subCase?.fieldMappings?.addresses?.forEach((address) => {
        Object.values(address).forEach((field) => {
          if (
            field.displayName &&
            field.displayName.trim() &&
            !uniqueHeaders.has(field.displayName)
          ) {
            addressFields.push(field.displayName);
            uniqueHeaders.add(field.displayName);
          }
        });
      });

      addressFields?.forEach((fieldDisplayName) => {
        headerRow.push(fieldDisplayName);
        uniqueHeaders.add(fieldDisplayName);
      });

      tableData.unshift(headerRow);
      return tableData;
    },

    closeExportDialog() {
      this.exportDialog = false;
    },
    employeeFullName(item) {
      if (item && item.length) {
        const mergedName = item.map((el) => fullName(el));
        return mergedName?.join(", ");
      }
      return "";
    },
    mergedEmployeeId(item) {
      if (item && item.length) {
        const mergedId = item.map((el) => el.employeeId);
        return mergedId.join(", ");
      }
      return "";
    },
    reportingManager(item) {
      if (item && item.length) {
        const managers = item.map((el) => {
          if (el.reportesTo) {
            return `${el.reportesTo.firstName} ${el.reportesTo.lastName}`;
          }
          return "";
        });

        return managers.join(", ");
      }
      return "";
    },
    handleExportKeys() {
      const exportOptions = this.prepareExportData(this.cases);
      if (exportOptions?.length > 0) {
        let maxKeysObject = exportOptions.reduce((prev, current) => {
          return Object.keys(current)?.length > Object.keys(prev)?.length
            ? current
            : prev;
        });
        this.exportColumnHeaders = Object.keys(maxKeysObject).map((key) => ({
          text: key,
          value: key,
        }));
      } else {
        this.exportColumnHeaders = [];
      }
      this.exportDialog = true;
    },

    prepareExportData(dataCopy) {
      const configLang = this.caseConfig.fieldMappings;

      return dataCopy.map((item, index) => {
        const {
          taskDescription,
          taskTitle,
          caseNo,
          bkt,
          pos,
          emiAmount,
          tenure,
          assignedTo,
          typeOfLoan,
          crn,
          customerFullName,
          productInfo,
          status,
          caseOutcomeStatus,
        } = configLang || {};

        const descriptionDisplayName =
          taskDescription?.displayName || "Description";
        const taskDisplayName = taskTitle?.displayName || "Task Title";
        const tasks = [...(item.tasks || [])].reverse();

        const mergeRemarks = (type) =>
          tasks
            .filter((task) =>
              type === "call" ? task.callInfo?.length : !task.callInfo
            )
            .map(
              ({ actualStartDateTime, meetingDetails }) =>
                `${this.$dayjs(actualStartDateTime).format(
                  "DD/MM/YYYY hh:mm:ss A"
                )} : ${meetingDetails?.meetingNotes}`
            )
            .join("  ||  ");

        const mergeVisitRemarks = mergeRemarks("visit");
        const mergeCallRemarks = mergeRemarks("call");

        const taskFields = tasks.reduce((fields, task, taskIndex) => {
          const {
            actualStartDateTime,
            actualEndDateTime,

            taskTitle,
            taskDescription,
            taskStatus,
            meetingDetails,
            additionalInfo,
          } = task;

          return {
            ...fields,
            "Merged Visit Remarks": mergeVisitRemarks,
            "Merged Call Remarks": mergeCallRemarks,
            [`${taskDisplayName}`]: taskTitle,
            [`Visit ${taskIndex + 1}`]: taskTitle,
            [`${descriptionDisplayName}`]: taskDescription,
            [`Visit Start ${taskIndex + 1}`]: actualStartDateTime
              ? this.$dayjs(actualStartDateTime).format("DD/MM/YYYY hh:mm A")
              : "",
            [`Visit End ${taskIndex + 1}`]: actualEndDateTime
              ? this.$dayjs(actualEndDateTime).format("DD/MM/YYYY hh:mm A")
              : "",
            [`Next visit date of visit ${taskIndex + 1}`]: actualEndDateTime
              ? this.$dayjs(meetingDetails?.nextTaskScheduledOn).format(
                  "DD/MM/YYYY hh:mm A"
                )
              : "",
            [`Visit Status ${taskIndex + 1}`]: taskStatus,
            [`Meeting Note ${taskIndex + 1}`]: meetingDetails?.meetingNotes,
            [`Meeting Outcome ${taskIndex + 1}`]:
              meetingDetails?.meetingOutCome,
            [`Fund Collected ${taskIndex + 1}`]: meetingDetails?.fundCollected,
            [`Image Link ${taskIndex + 1}`]: additionalInfo?.selfie
              ? `${this.awsBaseUrl}${additionalInfo.selfie.doc_physical_path}`
              : "",
            [`Audio Link ${taskIndex + 1}`]: additionalInfo?.audio
              ? `${this.awsBaseUrl}${additionalInfo.audio.doc_physical_path}`
              : "",
          };
        }, {});

        const additionalData = Object.entries(
          item?.additionalColumns || {}
        ).reduce((columns, [key, value]) => {
          columns[key] = value || "";
          return columns;
        }, {});

        return {
          "S.No": index + 1,
          [`${caseNo?.displayName || "Case No"}`]: item.caseNo || "",
          [`${bkt?.displayName || "BKT"}`]: item.bkt || "",
          [`${pos?.displayName || "POS"}`]: item.pos || "",
          [`${emiAmount?.displayName || "EMI Amount"}`]: item.emiAmount || "",
          [`${tenure?.displayName || "Tenure"}`]: item.tenure || "",
          [`${assignedTo?.displayName || "Assigned To"} (Full Name)`]:
            this.employeeFullName(item.assignedTo) || "",
          "Employee Id": this.mergedEmployeeId(item.assignedTo),
          "Reporting To": this.reportingManager(item.assignedTo),
          [`${typeOfLoan?.displayName || "Type of Loan"}`]:
            item.typeOfLoan || "",
          [`${crn?.displayName || "CRN"}`]: item.customer?.crn || "",
          [`${customerFullName?.displayName || "Customer Full Name"}`]:
            item.customer?.customerFullName || "",
          [`${productInfo?.displayName || "Product Info"}`]: item.productInfo,
          "Case Start On": item.caseStartDate
            ? this.$dayjs(item.caseStartDate).format("DD/MM/YYYY hh:mm A")
            : "",
          "Case Closed On": item.caseEndDate
            ? this.$dayjs(item.caseEndDate).format("DD/MM/YYYY hh:mm A")
            : "",
          TAT: this.calculateTAT(item),
          [`${status?.displayName || "Case Status"}`]: item.status,
          [`${caseOutcomeStatus?.displayName || "Case Outcome"}`]:
            item.userDefinedCaseStatus || "",
          ...taskFields,
          ...additionalData,
          [`${assignedTo?.displayName || "Assigned To"}`]: this.employeeMobile(
            item.assignedTo
          ),
        };
      });
    },
    async exportCases(selectedKeys) {
      try {
        const chunkSize = 50;
        this.exportLoading = true;
        const totalPages = Math.ceil(this.totalItems / chunkSize);

        const promises = [];

        for (let index = 0; index < totalPages; index++) {
          const filterParams = this.filterParams();

          const params = {
            limit: chunkSize,
            page: index + 1,
            ...filterParams,
          };
          const promise = this.$axios.get("/workforce/collection/cases", {
            params,
          });
          promises.push(promise);
        }

        const responses = await Promise.all(promises);

        const data = responses.reduce((acc, response) => {
          return acc.concat(response.data.cases);
        }, []);
        const XLSX = require("xlsx");
        const dataCopy = [...data];
        const restructuredData = this.prepareExportData(dataCopy);
        const filteredData = restructuredData.map((row) => {
          const filteredRow = {};
          selectedKeys.forEach((key) => {
            filteredRow[key] = row[key];
          });
          return filteredRow;
        });
        const ws = XLSX.utils.json_to_sheet(filteredData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Task Data");
        const file_date = new Date().toISOString();
        const filename = `${this.caseConfig?.name}_${file_date}.xlsx`;
        XLSX.writeFile(wb, filename);

        const storageKeyName = "exportColumnSelectedKey";
        const existingStorage =
          JSON.parse(localStorage.getItem(storageKeyName)) || {};
        const userId = this.userOrg?._id;
        const caseType = this.caseConfig.name;

        if (!existingStorage[userId]) {
          existingStorage[userId] = [];
        }

        const caseIndex = existingStorage[userId].findIndex(
          (entry) => entry.caseType === caseType
        );

        if (caseIndex > -1) {
          existingStorage[userId][caseIndex].selectedKeys = selectedKeys;
        } else {
          existingStorage[userId].push({
            useCase: "collection",
            caseType: caseType,
            selectedKeys: selectedKeys,
          });
        }

        localStorage.setItem(storageKeyName, JSON.stringify(existingStorage));
      } catch (error) {
        console.error("Error exporting data:", error);
      } finally {
        this.exportLoading = false;
      }
    },
    async fetchTeams() {
      try {
        const response = await this.$axios.get("/workforce/branches");
        this.branches = response.data.branches;
      } catch (error) {
        console.error("Error fetching branches:", error);
      }
    },
    calculateTAT(item) {
      const caseStart = item.caseStartDate;
      const caseEnd = item.caseEndDate;
      if (caseEnd) {
        return dayHourFormat(caseStart, caseEnd);
      }
      return "-";
    },
    findBranch(item) {
      if (item) {
        const branch = this.branches.find((el) => el._id === item.branch);
        return branch?.branchName || "-";
      }
      return "";
    },
    casesEdit(item) {
      this.openEditCase = true;
      this.editCase = item;
    },
    employeeMobile(arr) {
      if (arr && arr.length) {
        const mergedNumber = arr.map((el) => {
          return el.mobile;
        });
        return mergedNumber.join(", ") || "-";
      }

      return "N/A";
    },
    toolTipName(arr) {
      if (arr && arr.length) {
        const mergedName = arr.map((el) => {
          return `${el.firstName} ${el.lastName}`;
        });
        return mergedName.join(", ") || "Un-assigned";
      }
      return arr?.firstName || "Un-assigned";
    },
    addCaseTask(item) {
      this.editCase = item;
      this.openAddCaseTask = true;
    },
    uploadCases(text) {
      this.caseAction = text;
      this.openUploadCases = true;
    },
    closeUpload() {
      this.openUploadCases = false;
    },
    caseDetails(item) {
      this.openCaseDetails = true;
      this.selectedCase = item;
    },
    formatDate(dateString) {
      return this.$dayjs(dateString).format("YYYY-MM-DD");
    },
    visibleDate(date) {
      return this.$dayjs(date).format("DD-MM-YYYY");
    },
    cancel() {
      this.showConfirmationDialog = false;
      this.fetchCases();
    },
    cancelVisitUpdate() {
      this.showUpdateVisitDialog = false;
      this.visitAssignedTo = null;
      this.visitId = null;
      this.newAssignedTo = null;
      this.fetchCases();
    },
    handleAdded() {
      this.openEditCase = false;
      this.openAddCaseTask = false;
      this.fetchCases();
    },
    closeDialog() {
      this.openCaseDetails = false;
      this.fetchCases();
    },
    addNewCase() {
      this.editCase = null;
      this.openEditCase = true;
    },
    convertTitle(str) {
      if (str) {
        return convertToTitleCase(str);
      }
      return "-";
    },
    handleInput: debounce(async function () {
      this.options.page = 1;
      await this.fetchCases();
    }, 800),
    updateSelectedCount() {
      this.selectedCount = [
        this.filterAssignedTo,
        this.filterCaseOutcome,
        this.filterStatus,
        this.formattedDate,
      ].filter(
        (item) => item !== null && item !== "" && item.length > 0
      ).length;
    },
    handleChange() {
      this.handleInput();
      this.updateSelectedCount();
    },
    handleShowDialog(label) {
      this.dialogLable = label;
      this.showDialog = !this.showDialog;
      if (this.showDialog === false) {
        this.fetchCases();
      }
    },
    handleShowDialogDelete(label) {
      this.dialogLable = label;
      this.showDeleteDialog = !this.showDeleteDialog;
      if (this.showDeleteDialog === false) {
        this.fetchCases();
      }
      this.deleteCustomer = false;
    },

    handleShowDialogDeleteAll(label) {
      this.dialogLable = label;
      this.showDeleteAllDialog = !this.showDeleteAllDialog;
      if (this.showDeleteAllDialog === false) {
        this.fetchCases();
      }
    },
    handleDeleteSelected() {
      this.selected = [];
    },
    handleUnassignedCases() {
      this.filterAssignedTo = "null";
      this.handleChange();
    },
    async handleSelect() {
      this.filterCase = "";
      await this.fetchCases();
    },
  },
  async mounted() {
    await this.fetchTeams();
  },
};
</script>
<style scoped>
.v-data-table-header th span {
  font-size: 14px;
  color: #262626;
  font-weight: 400;
}

.v-data-table
  >>> .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td
  > .v-data-table__checkbox {
  text-align: center;
}
</style>

<style scoped>
.wfm-search-fields.v-text-field--outlined > .v-input__control > .v-input__slot {
  min-height: 40px !important;
}
.unassignedOptions {
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: #ffffff;
}
.v-list {
  padding-top: 0px !important;
}
.custom-input-group {
  display: flex;
  align-items: center;
  padding: 2px;
  background-color: white;
  border-radius: 5px;
}

.select-input {
  flex-grow: 1;
  width: 15%;
  font-size: smaller;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}

.text-input {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
</style>
